export default function Loader({ fullscreen = false, size = 32 }) {
  if (fullscreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-cream-100/80 backdrop-blur-sm z-50">
        <div className="loader-spin" style={{ width: size, height: size }} />
      </div>
    );
  }
  return (
    <div className="flex items-center justify-center p-10">
      <div className="loader-spin" style={{ width: size, height: size }} />
    </div>
  );
}
